"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const config_1 = require("config");
const utils_1 = require("utils");
const AcceptTermsAndSign_1 = __importDefault(require("./AcceptTermsAndSign"));
function AcceptTermsShell({ getNewDealTerms, locationData, signNewDealTerms, markedCompleteOrSkipped, }) {
    const [allTerms, setAllTerms] = (0, react_1.useState)([]);
    const locationIds = locationData.map((location) => location.locationId);
    const history = (0, react_router_dom_1.useHistory)();
    async function createTermsList() {
        const uniqueTerms = [];
        for (let i = 0; i < locationIds.length; i++) {
            const terms = await getNewDealTerms(`${locationIds[i]}`);
            terms.forEach((term) => {
                if (!JSON.stringify(uniqueTerms).includes(JSON.stringify(term))) {
                    uniqueTerms.push(term);
                }
            });
        }
        setAllTerms(uniqueTerms);
    }
    (0, react_1.useEffect)(() => {
        createTermsList();
    }, []);
    const handleSubmit = async (values) => {
        let isError = false;
        if (Object.keys(markedCompleteOrSkipped).length === 0 ||
            Object.keys(markedCompleteOrSkipped).length < locationIds.length) {
            (0, utils_1.toastError)('Please verify your practice information or click skip before submitting');
            return;
        }
        for (let i = 0; i < locationIds.length; i++) {
            if (markedCompleteOrSkipped[locationIds[i]] !== 'marked_as_completed') {
                continue;
            }
            const termIds = allTerms.map((term) => {
                return { termContentId: term.termContentId };
            });
            const body = {
                terms: termIds,
                signer: { firstName: values.firstName, lastName: values.lastName },
            };
            await signNewDealTerms(`${locationIds[i]}`, body).catch((e) => {
                isError = true;
                (0, utils_1.toastError)(e.response.message);
            });
        }
        if (!isError) {
            history.push({
                pathname: (0, config_1.makeMerchantPortalPath)(config_1.PATH.NEW_DEAL + config_1.PATH.DOC_UPLOAD),
                state: {
                    from: '/new-deal',
                    storeInfo: locationData,
                },
            });
        }
    };
    return (0, jsx_runtime_1.jsx)(AcceptTermsAndSign_1.default, { handleSubmit: handleSubmit, terms: allTerms });
}
function mapStateToProps() {
    return {};
}
const mapApiAuthToProps = {
    getNewDealTerms: apiActions.getNewDealTerms,
    signNewDealTerms: apiActions.signNewDealTerms,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(AcceptTermsShell);
